import api from '../baseAPIs/core';
import { VersionInfo } from '@extTypes/versioning';
import { OptionSetDto } from '@extTypes/options/optionSet';

export const listOptionSetVersions = async (id: string): Promise<VersionInfo[]> => {
    const response = await api.get<VersionInfo[]>(`/OptionSet/${id}/Versions`);
    return response.data;
};

export const getOptionSetFromVersion = async (key: string, versionId: string): Promise<OptionSetDto> => {
    const response = await api.get<OptionSetDto>(`/OptionSet/Version`, {
        params: { key, versionId }
    });
    return response.data;
};
